var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import Loader from '@components/v2/Loader';
import ComponentStatusesTable from './ComponentStatusesTable';
import AddComponentStatusModal from './components/AddComponentStatusModal';
import ComponentStatusDetailModal from './components/ComponentStatusDetailModal';
import { useComponentStatuses, useUpdateComponentStatusMutation, useDeleteComponentStatusMutation, useSetComponentStatusAsDefaultMutation } from './hooks/useComponentStatusesMutations';
import './ComponentStatusesSettingsStyles.scss';
const namespace = 'features.settings.component_statuses';
export default function ComponentStatusesSettings() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const { data: componentStatuses = [], isLoading, isError, error } = useComponentStatuses();
    const updateMutation = useUpdateComponentStatusMutation();
    const deleteMutation = useDeleteComponentStatusMutation();
    const setDefaultMutation = useSetComponentStatusAsDefaultMutation();
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleStatusClick = (status) => {
        setSelectedStatus(status);
        setIsDetailModalOpen(true);
    };
    const handleEditClick = (status) => {
        setSelectedStatus(status);
        setIsDetailModalOpen(true);
    };
    const handleCloseDetailModal = () => {
        setIsDetailModalOpen(false);
        setSelectedStatus(null);
    };
    const handleUpdateStatus = (statusId, field, value) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield updateMutation.mutateAsync({
                id: statusId,
                data: { [field]: value }
            });
        }
        catch (updateError) {
            console.error('Failed to update component status:', updateError);
            throw updateError;
        }
    });
    const handleDeleteStatus = (statusId) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield deleteMutation.mutateAsync(statusId);
            handleCloseDetailModal();
        }
        catch (deleteError) {
            console.error('Failed to delete component status:', deleteError);
            throw deleteError;
        }
    });
    const handleSetDefaultClick = (status) => {
        if (!status.isDefault) {
            setDefaultMutation.mutate(status.id);
        }
    };
    if (isLoading) {
        return (React.createElement("div", { className: "component-statuses-settings" },
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "loading-state" },
                    React.createElement(Loader, { label: translate('loading', { namespace: 'features.commons' }) })))));
    }
    if (isError) {
        return (React.createElement("div", { className: "component-statuses-settings" },
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "error-state" },
                    React.createElement("i", { className: "fa-light fa-exclamation-triangle", "aria-hidden": "true" }),
                    React.createElement("p", null, translate('error_loading', { namespace })),
                    React.createElement("p", null, error === null || error === void 0 ? void 0 : error.message)))));
    }
    return (React.createElement("div", { className: "component-statuses-settings" },
        React.createElement("div", { className: "content" },
            React.createElement("header", { className: "content-header" },
                React.createElement("div", { className: "content-header__left" },
                    React.createElement("h1", { className: "content-header__title" }, translate('title', { namespace }))),
                React.createElement("div", { className: "content-header__right" },
                    React.createElement(Button, { variant: "secondary", onClick: handleOpenModal },
                        React.createElement("i", { className: "fa-light fa-plus", "aria-hidden": "true" }),
                        translate('new_status', { namespace })))),
            React.createElement("hr", { className: "content-separator" }),
            React.createElement("div", { className: "content-table" },
                React.createElement("p", { className: "content-description" }, translate('description', { namespace })),
                React.createElement(ComponentStatusesTable, { componentStatuses: componentStatuses, onStatusClick: handleStatusClick, onEditClick: handleEditClick, onSetDefaultClick: handleSetDefaultClick }))),
        React.createElement(AddComponentStatusModal, { isOpen: isModalOpen, onClose: handleCloseModal }),
        React.createElement(ComponentStatusDetailModal, { isOpen: isDetailModalOpen, onClose: handleCloseDetailModal, componentStatus: componentStatuses.find((status) => status.id === (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.id)) || null, onUpdate: handleUpdateStatus, onDelete: handleDeleteStatus, isUpdating: updateMutation.isLoading, isDeleting: deleteMutation.isLoading })));
}
